import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { IconButton } from 'seagull';
import styles from './ColorSelector.module.scss';
/**
 * Renders a clickable circle filled with a specified color. Selected state is shown by
 * outline only (no checkmark). Empty color shows a dashed circle (triggers custom color panel).
 */ export function ColorSelector(props) {
    const { color, selected, disabled, withBorder, hasError, size = 's', testId, onClick } = props;
    const isEmpty = !color;
    return /*#__PURE__*/ _jsx(IconButton, {
        className: cn(withBorder && styles.border, hasError && styles.hasError),
        skin: "transparent",
        size: size === 'l' ? 'medium' : 'small',
        noPadding: true,
        disabled: disabled,
        testId: testId,
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.circle, {
                [styles.selected]: selected && !isEmpty,
                [styles.empty]: isEmpty
            }),
            style: color ? {
                background: color
            } : undefined
        })
    });
}
